"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const locationpin = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-locationpin" : '') + (description ? " desc-locationpin" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-locationpin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-locationpin"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_1245_1732)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.252 0.645304L1.77103 8.56677C0.874788 8.94771 0.281586 9.81472 0.251221 10.7881L0.25213 10.9697C0.289406 11.8724 0.813285 12.691 1.62962 13.0998L7.925 16.2475L11.075 22.5468C11.5115 23.4169 12.4119 23.9544 13.3838 23.9258C14.3558 23.8972 15.223 23.3075 15.6071 22.4142L23.5459 3.92696C23.9519 2.98611 23.7415 1.89135 23.0149 1.16701C22.2882 0.442668 21.1928 0.235819 20.252 0.645304ZM21.9559 2.22936C22.2466 2.51911 22.3307 2.95704 22.1681 3.33389L14.2289 21.8221C14.0754 22.1791 13.7285 22.415 13.3397 22.4265C12.9509 22.4379 12.5907 22.2229 12.4163 21.8752L9.15659 15.354C9.08402 15.2088 8.96631 15.0911 8.82114 15.0185L2.30086 11.7584C1.95334 11.5843 1.73836 11.2238 1.75049 10.8349C1.76262 10.4459 1.99966 10.0995 2.35988 9.94636L20.8468 2.02233C21.227 1.85686 21.6652 1.9396 21.9559 2.22936Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_1245_1732"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = locationpin;